import React from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import TemplateCard from './TemplateCard';
import { TemplateGridProps } from './types';

const TemplateGrid: React.FC<TemplateGridProps> = ({
  templates,
  onEdit,
  onDuplicate,
  onDelete,
  onSetDefault,
  onToggleActive,
  saving,
  emptyMessage = 'No templates found'
}) => {
  if (templates.length === 0) {
    return (
      <div className="text-center py-16 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
        <svg
          className="mx-auto h-16 w-16 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        <h3 className="mt-4 text-lg font-medium text-gray-900">
          {emptyMessage}
        </h3>
        <p className="mt-2 text-sm text-gray-600 max-w-sm mx-auto">
          Create your first form template to customize which fields appear when creating new leads.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {templates.map((template) => (
        <TemplateCard
          key={template.id}
          template={template}
          onEdit={onEdit}
          onDuplicate={onDuplicate}
          onDelete={onDelete}
          onSetDefault={onSetDefault}
          onToggleActive={onToggleActive}
          saving={saving}
        />
      ))}
    </div>
  );
};

export default TemplateGrid;
